import state from './state'
import mutations from './mutations'
import actions from './actions/index'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
